export default {
  'title.doctor': 'Healthcare professionals',
  'title.patient': 'Patients',

  'header.search': 'Search',

  'mainNav.professionals': 'Healthcare professionals',
  'mainNav.patients': 'Patients',
  'mainNav.partners': 'Partners',
  'mainNav.service': 'Service',
  'mainNav.questions': 'Questions',

  'footerNav.privacyPolicy': 'Privacy Policy',
  'footerNav.termsOfUse': 'Terms of Use',

  'productDrawer.tabs.overview': 'Overview',
  'productDrawer.tabs.indications': 'Indications',
  'productDrawer.tabs.techSpecs': 'Tech specs',
}



// WEBPACK FOOTER //
// ./src/intl/en.js